export function cleanDocument(cpfOrCnpj?: string | null): string {
  return cpfOrCnpj !== undefined && cpfOrCnpj !== null
    ? cpfOrCnpj.replace(/[^\d]/gi, '')
    : '';
}
